import 'js/common.js'
import Vue from 'vue'
import Index from 'component/Index.vue'

new Vue({
    el: '#app',
    render: h => h(Index)
})


// WEBPACK FOOTER //
// ./src/entry/index.js